<!-- Button -->
<button mat-icon-button [matTooltip]="'Help Center' | transloco" [routerLink]="['/help-center']">
  <span class="relative">
    <mat-icon
      [ngClass]="isArabic ? 'mirror mr-2' : 'ml-1'"
      svgIcon="mat_solid:help_outline"
    ></mat-icon>
  </span>
</button>

<!--  [matMenuTriggerFor]="helpActions"-->

<!--<mat-menu [xPosition]="'before'" #helpActions="matMenu">-->
<!--  <button mat-menu-item [routerLink]="['/frequently-asked-questions']">-->
<!--    <mat-icon [svgIcon]="'mat_outline:question_answer'"></mat-icon>-->
<!--    <span>{{ 'FAQs' | transloco }}</span>-->
<!--  </button>-->

<!--  <mat-divider class="my-2"></mat-divider>-->
<!--  <button mat-menu-item [routerLink]="['/help-center']">-->
<!--    <mat-icon [svgIcon]="'mat_outline:support'"></mat-icon>-->
<!--    <span>{{ 'Help Center' | transloco }}</span>-->
<!--  </button>-->
<!--</mat-menu>-->
